import { Answer } from "./answer";
import { Chapter } from "./chapter";
import { Lesson } from "./lesson";
import { Progress } from "./progress";
import { Question } from "./question";
export const ApiEpAcademy = {
    Answer,
    Chapter,
    Lesson,
    Progress,
    Question,
};
//# sourceMappingURL=academy.js.map